import React from "react";
import { motion } from "framer-motion";
import waterImage from "../../assets/about5.jpeg";

const LandingPage = () => {
  const handleClick = () => {
    window.location.href =
      "https://api.whatsapp.com/send/?phone=6281319259694&text&type=phone_number&app_absent=0";
  };

  const scrollToServices = () => {
    const element = document.getElementById("OurServices");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="LandingPage"
      className="relative min-h-screen flex items-center pt-28 pb-20 bg-slate-950 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={waterImage}
          alt="Pengolahan Limbah Cair"
          className="w-full h-full object-cover scale-105"
          style={{ filter: "brightness(0.35)" }}
        />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-brand-900/80 via-slate-900/60 to-eco-900/70" />
        {/* Mesh gradient blur orbs */}
        <div className="absolute -top-32 -left-32 w-96 h-96 bg-brand-500/30 rounded-full blur-3xl animate-pulse-soft" />
        <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] bg-eco-500/25 rounded-full blur-3xl animate-pulse-soft" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center gap-12">
          {/* Text Column */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col justify-center text-white lg:col-span-7"
          >
            {/* Badge */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center gap-2 self-start px-4 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-md mb-6"
            >
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-eco-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-eco-500" />
              </span>
              <span className="text-xs sm:text-sm font-medium tracking-wider uppercase">
                Water Tech Specialist
              </span>
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="font-oswald text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-6 max-w-3xl"
            >
              Solusi{" "}
              <span className="relative inline-block">
                <span className="relative z-10 bg-gradient-to-r from-brand-300 to-eco-300 bg-clip-text text-transparent">
                  Air Bersih
                </span>
              </span>{" "}
              dan Pengolahan{" "}
              <span className="bg-gradient-to-r from-eco-300 to-brand-300 bg-clip-text text-transparent">
                Limbah Cair
              </span>{" "}
              Terdepan
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="text-base sm:text-lg text-slate-200 leading-relaxed max-w-2xl mb-8 font-overpass"
            >
              Kami berkomitmen menyediakan solusi terbaik dalam penyediaan
              teknologi air bersih dan pengolahan limbah yang efektif dan ramah
              lingkungan untuk masyarakat yang lebih sehat.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="flex flex-wrap gap-4"
            >
              <button onClick={scrollToServices} className="btn-primary group">
                Layanan Kami
                <span className="inline-block transition-transform group-hover:translate-x-1">
                  →
                </span>
              </button>
              <button onClick={handleClick} className="btn-outline group">
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Konsultasi Gratis
              </button>
            </motion.div>
          </motion.div>

          {/* SDG Image Column */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5 flex flex-col gap-6 items-center"
          >
            <motion.div
              animate={{ y: [0, -12, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
              className="relative p-6 rounded-3xl bg-white/10 border border-white/20 backdrop-blur-md shadow-2xl w-full max-w-sm"
            >
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-brand-400/20 to-eco-400/20 -z-10 blur-xl" />
              <img
                src="https://defra.co.id/images/theother/SDGLOGO.png"
                alt="Sustainable Development Goals"
                className="w-full h-auto object-contain rounded-xl"
              />
            </motion.div>
            <motion.div
              animate={{ y: [0, 12, 0] }}
              transition={{
                duration: 7,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 1,
              }}
              className="relative p-6 rounded-3xl bg-white/10 border border-white/20 backdrop-blur-md shadow-2xl w-full max-w-xs"
            >
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-eco-400/20 to-brand-400/20 -z-10 blur-xl" />
              <img
                src="https://defra.co.id/images/theother/SDGLOGO2.png"
                alt="Sustainable Development Goals"
                className="w-full h-auto object-contain rounded-xl"
              />
            </motion.div>
          </motion.div>
        </div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
          className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 text-white/70"
        >
          <span className="text-xs tracking-widest uppercase">Scroll</span>
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-5 h-8 rounded-full border-2 border-white/40 flex justify-center pt-1.5"
          >
            <div className="w-1 h-2 rounded-full bg-white/70" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default LandingPage;
